<template>
  <div>
    <v-layout column justify-center wrap mt-2>
      <v-flex xs12 md4 lg3 xl2 px-2 v-if="!readonly">
        <v-layout column align-center justify-center fill-height px-2>
          <v-btn v-if="desarrollo" style="width:100%" class="mt-0" color="primary" @click="$emit('autocompletar', comprador)">
            {{$t('reservas.formularioFisico.autorellenar')}}
          </v-btn>
        </v-layout>
      </v-flex>
      <v-flex xs12 :md8="!readonly" :lg9="!readonly" :xl10="!readonly">
        <v-layout row wrap>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-text-field
              :label="$t('general.misc.nombre')"
              :name="'nombre[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(50)]"
              v-model="comprador.nombre"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-select
              :label="$t('reservas.formularioJuridico.tipoDocumento')"
              :name="'tipoDocumentoID[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar)]"
              :items="[{DESC_TIPO_DOCUMENTO_ID: 'CIF', COD_TIPO_DOCUMENTO_ID: 'C'}]"
              item-text="DESC_TIPO_DOCUMENTO_ID"
              item-value="COD_TIPO_DOCUMENTO_ID"
              v-model="comprador.tipoDocumentoID"
              :disabled="true"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-text-field
              :label="$t('reservas.formularioJuridico.numDocumento')"
              :name="'cif[' + indice + ']'"
              :value="comprador.nif"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(20), rules.numberUppercase, rules.validarIf(guardarYEnviar, rules.validarCif(comprador.tipoDocumentoID))]"
              @input="comprador.nif = $event != null ? $event.toUpperCase() : $event"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-autocomplete
              :label="$t('reservas.formularioFisico.nacionalidad')"
              :name="'nacionalidad[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(20)]"
              :items="getNacionalidades"
              item-text="denominacionNacionalidad"
              item-value="codigoNacionalidad"
              v-model="comprador.codigoNacionalidad"
              :disabled="bloquearCampos"
              :readonly="readonly"
              :clearable="!readonly"
              browser-autocomplete="OVERNACIONALIDAD"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-autocomplete
              :label="$t('reservas.formularioJuridico.pais')"
              :name="'pais[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(20)]"
              :items="getPaises"
              item-text="denominacionPais"
              item-value="codigoPais"
              v-model="comprador.codigoPais"
              :disabled="bloquearCampos"
              :readonly="readonly"
              :clearable="!readonly"
              browser-autocomplete="OVERJURIDICOPAIS"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>            
            <select-pre-load-item 
              v-model="comprador.codigoProvincia" 
              :label="$t('reservas.formularioFisico.provincia')"
              :name="'provincia['+indice+']'"
              :llamada="loadProvincias"
              codigo="codigoProvincia"
              :codigoLlamada="comprador.codigoPais != null ? comprador.codigoPais : null"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-text-field
              :label="$t('reservas.formularioFisico.poblacion')"
              :name="'poblacion[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(128)]"
              v-model="comprador.poblacion"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-autocomplete
              :label="$t('reservas.formularioFisico.tipoVia')"
              :name="'tipoVia[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar)]"
              :items="getTiposVias"
              item-text="descripcionVia"
              item-value="codigoVia"
              v-model="comprador.codigoTipoVia"
              :disabled="bloquearCampos"
              :readonly="readonly"
              :clearable="!readonly"
              browser-autocomplete="OVERTIPOVIA"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-text-field
              :label="$t('reservas.formularioFisico.domicilio')"
              :name="'domicilio[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
              v-model="comprador.domicilio"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-text-field
              :label="$t('reservas.formularioFisico.cp')"
              :name="'codigoPostal[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(10)]"
              v-model="comprador.codigoPostal"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-autocomplete
              :label="$t('reservas.formularioJuridico.actividadPrincipal')"
              :name="'actividadPrincipal[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(5)]"
              :items="getActividadesProfesionales"
              item-text="descripcionActividad"
              item-value="codigoActividad"
              v-model="comprador.kycJuridico.codigoActividadProfesional"
              :disabled="bloquearCampos"
              :readonly="readonly"
              :clearable="!readonly"
              browser-autocomplete="OVERACTIVIDADPRINCIPAL"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <o-date-picker
              :label="$t('reservas.formularioJuridico.fechaConstitucion')"
              :name="'fechaConstitucion[' + indice + ']'"
              :obligatorio="guardarYEnviar"
              v-model="comprador.kycJuridico.fechaConstitucion"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2 >
            <v-text-field
              :label="$t('reservas.formularioJuridico.notarioConstitucion')"
              :name="'notario[' + indice + ']'"
              v-model="comprador.kycJuridico.notarioConstitucion"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
              :disabled="bloquearCampos"
              :readonly="readonly"
            />
          </v-flex>
          <v-flex xs12 md6 lg4 xl3 px-2>
            <v-text-field
              :label="$t('reservas.formularioJuridico.poblacionConstitucion')"
              :name="'poblacionConstitucion[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.max(128)]"
              v-model="comprador.kycJuridico.poblacionConstitucion"
              :disabled="bloquearCampos"
              :readonly="readonly"
              browser-autocomplete="OVERJURIDICOPOBLACIONC"
            />
          </v-flex>
          <v-flex xs12 md12 lg4 xl6 px-2>
            <v-text-field
              :label="$t('reservas.formularioFisico.email')"
              :name="'email[' + indice + ']'"
              :rules="[rules.requiredIf(guardarYEnviar), rules.emailOpcional, rules.max(256)]"
              v-model="comprador.email"
              :readonly="readonly"
            >
              <template slot="append">
                <v-tooltip bottom>
                  <template #activator="{on}">
                    <v-icon small v-on="on" @click.stop>
                      info
                    </v-icon>
                  </template>
                  <span>{{$t('reservas.kyc.tooltipEmail')}}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs12 md7 lg6 xl6 px-2>
            <v-autocomplete
              hide-details
              v-model="comprador.codigoPrefijoTelefonicoId"
              :name="'prefijo[' + indice + ']'"
              :items="prefijos"
              :label="$t('reservas.formularioFisico.prefijo')"
              item-text="nombre"
              item-value="id"
              :rules="[rules.requiredIf(guardarYEnviar)]"
              :readonly="readonly"
              @change="validarLongitudTelefono"
            />
          </v-flex> 
          <v-flex xs12 md5 lg6 xl6 px-2>
            <v-text-field
              :name="'numTelefono[' + indice + ']'"
              :label="$t('reservas.formularioFisico.telefono')"
              :rules="[rules.requiredIf(guardarYEnviar), rules.integerNumber0, rules.max(14 - longitudPrefijo(comprador.codigoPrefijoTelefonicoId))]"
              v-model="comprador.numTelefono"
              :readonly="readonly"
              ref="numTelefono"
            >
              <template slot="append">
                <v-tooltip bottom>
                  <template #activator="{on}">
                    <v-icon small v-on="on" @click.stop>
                      info
                    </v-icon>
                  </template>
                  <span>{{$t('reservas.kyc.tooltipTelefono')}}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center v-if="!mostrarHastaEmail">
      <v-flex xs12 md6 lg4 xl4 px-2>
        <o-numeric-text-field
          :label="$t('reservas.formularioFisico.porcentajeOperacion')"
          :name="'participacion[' + indice + ']'"
          :rulesProps="[rules.requiredIf(guardarYEnviar), rules.porcentaje]"
          v-model="comprador.porcentajeParticipacion"
          suffix="%"
          :disabled="bloquearCampos"
          :readonly="readonly"
        />
      </v-flex>
      <v-flex xs12 md12 lg6 xl4 px-2>
        <v-radio-group
          v-model="comprador.titularCuenta"
          :rules="[rules.requiredIf(guardarYEnviar)]"
          :disabled="readonly || bloquearCampos"
        >
          <v-layout>
            <label d-inline-block class="mr-2 v-label">{{$t('reservas.formularioJuridico.titularCuenta')}}</label>
            <v-radio
              color="primary"
              :label="$t('reservas.formularioFisico.si')"
              :value="true"
              class="mb-0"
            />
            <v-radio
              color="primary"
              :label="$t('reservas.formularioFisico.no')"
              :value="false"
              class="mb-0"
            />
          </v-layout>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import MixinComprador from '@/mixins/comprador'
import moment from 'moment'

export default {
  mixins: [rules, MixinComprador],
  props: {
    comprador: {
      type: Object,
      required: true
    },
    mostrarIngresos: {
      type: Boolean,
      default: true
    },
    mostrarHastaEmail: {
      type: Boolean,
      default: false
    },
    indice: {
      type: Number,
      default: 0
    },
    bloquearCampos: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    guardarYEnviar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      getProvincias: 'maestros/provincias/getAll',
      getPaises: 'maestros/paises/getAll',
      getPaisById: 'maestros/paises/getById',
      getNacionalidades: 'maestros/nacionalidades/getAll',
      getActividadesProfesionales: 'maestros/actividadesProfesionales/getAll',
      getTiposVias: 'maestros/tiposVias/getAll',
      getTiposDocumentos: 'maestros/tiposDocumentos/getAll',
      prefijos: 'maestros/prefijos/getAll'
    }),
    imageWidth () {
      if (this.$vuetify.breakpoint.mdOnly) {
        return this.bloquearCampos ? '90%' : '70%'
      } else if (this.$vuetify.breakpoint.lgOnly) {
        return this.bloquearCampos ? '90%' : '70%'
      } else {
        return this.bloquearCampos ? '90%' : '67%'
      }
    }
  },
  methods: {
    ...mapActions({
      loadProvincias: 'maestros/provincias/loadProvincias'
    }),
    longitudPrefijo (codigoPrefijoTelefonicoId) {
      let pref = this.prefijos.find(x => x.id == codigoPrefijoTelefonicoId)
      if (pref == null) {
        return 0
      }
      return pref.codigo.length
    },
    async validarLongitudTelefono() {
      if (this.comprador.numTelefono != null) {
        await this.$nextTick()
        this.$refs.numTelefono.internalChange = true
        this.$refs.numTelefono.hasFocused = true
        this.$refs.numTelefono.validate()
      }
    },
    formatDate (d) {
      return d ? moment(d).format('DD/MM/YYYY') : null
    },
    actualizarTelefono () {
      let prefijo = this.prefijos.find(x => x.id === this.comprador.codigoPrefijoTelefonicoId)
      this.comprador.telefono = (prefijo != null ? prefijo.codigo : '+34') + (this.comprador.numTelefono != null ? this.comprador.numTelefono : '')
    }
  },
  watch: {
    'comprador.codigoPrefijoTelefonicoId': {
      handler () {
        this.actualizarTelefono()
      }
    },
    'comprador.numTelefono': {
      handler () {
        this.actualizarTelefono()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/comprador/FormularioCompradorJuridico.vue